
<footer *ngFor="let data of footer|orderBy:'listingorder'; let i= index">
  <div class="container-fluid text-center p-2" *ngIf="footer">
    <div class="footer" [innerHtml]="data.content|sanitizeHtml"></div>    
  </div>
</footer>
